import { createReducer } from '@reduxjs/toolkit'

import types from './types'

export { default as actions } from './actions'

export default createReducer(
  {},
  {
    [types.UPDATE_COLLAPSE_ACADEMIC_OVERVIEW]: (state, action) => {
      state.academicOverview = action.payload
    },
    [types.UPDATE_COLLAPSE_APPLICATION_STATUS]: (state, action) => {
      state.applicationStatus = action.payload
    },
    [types.UPDATE_COLLAPSE_CHECKLIST]: (state, action) => {
      state.checklist = action.payload
    },
    [types.UPDATE_COLLAPSE_DOCUMENT_STATUS]: (state, action) => {
      state.documentStatus = action.payload
    },
    [types.UPDATE_COLLAPSE_SCATTERGRAM]: (state, action) => {
      state.scattergram = action.payload
    },
    [types.UPDATE_COLLAPSE_PROSPECT_HISTORY]: (state, action) => {
      state.history = action.payload
    },
  },
)
